export const GradientsList = () => (
  <svg className="hidden">
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="green-gradient"
        x1="96.1288"
        x2="134.064"
        y1="12.141"
        y2="12.141"
      >
        <stop stopColor="#00B83E" />
        <stop offset="1" stopColor="#00B67D" />
      </linearGradient>
    </defs>

    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="pink-gradient"
        x1="0.357955"
        x2="28"
        y1="20"
        y2="20"
      >
        <stop stopColor="#B81D7A" />
        <stop offset="1" stopColor="#D6385E" />
      </linearGradient>
    </defs>
  </svg>
);
